import { defineStore } from 'pinia';
import { ILibraryDashboard } from '../services/api/library/types';
import { ref } from 'vue';

export const useDashboardLibraryStore = defineStore('dashboardLibrary', () => {
    const dashboards = ref<ILibraryDashboard[]>([]);
    const filteredDashboards = ref<ILibraryDashboard[]>([]);

    const setInitialDashboards = (data: ILibraryDashboard[]) => {
        dashboards.value = data;
        filteredDashboards.value = data;
    };

    const filterDashboards = (searchString: string) => {
        if (!searchString) {
            filteredDashboards.value = dashboards.value;
            return;
        }
        filteredDashboards.value = dashboards.value.filter((dashboard) => {
            const matchesSearch = searchString
                ? dashboard.title.toLowerCase().includes(searchString.toLowerCase())
                : true;
            return matchesSearch;
        });
    };

    return {
        filteredDashboards,
        setInitialDashboards,
        filterDashboards,
    };
});
